import * as ko from 'knockout';
import { Request } from 'Core/Common/Request';
import { P } from 'Core/Common/Promise';
import { BlockUI } from 'Core/Common/BlockUi';

import Template from './CollaboraDocumentEditorPage.html';

ko.templates['Pages/CollaboraDocumentEditorPage/Templates/CollaboraDocumentEditorPage'] = Template;

export class CollaboraDocumentEditorPage {
	private _isReady: KnockoutObservable<boolean>;
	private _iframeSrc: KnockoutObservable<string>;
	private _accessToken: KnockoutObservable<string>;

	constructor() {
		this._isReady = ko.observable(false);
		this._iframeSrc = ko.observable('');
		this._accessToken = ko.observable('');
	}

	GetTemplateName(): string {
		return 'Pages/CollaboraDocumentEditorPage/Templates/CollaboraDocumentEditorPage';
	}

	Render(target: string): void {
		ko.cleanNode(document.getElementById(target));
		ko.applyBindings(this, document.getElementById(target));
	}

	AfterRender(): void {
		this._isReady(true);
		this.InitEditor();
	}

	private InitEditor(): void {
		BlockUI.Block();

		const deferred = P.defer<any>();
		Request
			.For('/api/CollaboraDocumentEditorApi/GetEditorConfig?fileName=New Document.docx')
			.Get()
			.then((data: any) => deferred.resolve(data));

		deferred.promise().then((data: any) => {
			this._iframeSrc(data.iframeSrc);
			this._accessToken(data.accessToken);

			const iframe = document.getElementById('collabora-frame') as HTMLIFrameElement;
			iframe.style.height = (window.innerHeight - iframe.getBoundingClientRect().top) + 'px';

			setTimeout(() => {
				const form = document.getElementById('collabora-submit-form') as HTMLFormElement;
				form.submit();
				BlockUI.Unblock();
			}, 100);
		});
	}
}
